<h2 mat-dialog-title>
    {{ 'RECORDING_VISIBILITY.OVERRIDE_DIALOG.TITLE' | translate }}
  </h2>
  <mat-dialog-content>
    <div class="dialog-content">
      @if (namespaceName$ | async; as namespaceName) {
        <p>{{ 'RECORDING_VISIBILITY.OVERRIDE_DIALOG.DESCRIPTION' | translate: { namespaceName: namespaceName } }}</p>
        <glxy-form-field>
            <glxy-label>
              <div class="recording-title-container">
                <span class="recording-title">{{ 'RECORDING_VISIBILITY.TITLE_V2' | translate }}</span>
              </div>
            </glxy-label>
            <mat-select [ngModel]="isPrivacyLevelOverridden()" (valueChange)="changeSelectedPrivacyLevel($event)">
              <mat-option [value]="false">
                {{ 'RECORDING_VISIBILITY.DEFAULT' | translate }}
              </mat-option>
              <mat-option [value]="true">
                {{ 'RECORDING_VISIBILITY.OVERRIDE' | translate }}
              </mat-option>
            </mat-select>
            @if (overriddenPrivacy()?.userId) {
              <glxy-hint>{{
                  'RECORDING_VISIBILITY.UPDATED_BY' | translate: {
                    name: getFormattedDisplayName(userThatOverrodePrivacy()),
                    date: overriddenPrivacy()?.updated | date: 'MMM d, yyyy'
                  }
                }}
              </glxy-hint>
            }
          </glxy-form-field>
          @if (selectedPrivacyLevel() === PrivacyLevel.PRIVACY_LEVEL_PRIVATE) {
            <p>{{ 'RECORDING_VISIBILITY.DIALOG.OPTION_2_DESCRIPTION' | translate: { namespaceName: namespaceName } }}</p>
          } @else {
            <p>{{ 'RECORDING_VISIBILITY.DIALOG.OPTION_1_DESCRIPTION' | translate: { namespaceName: namespaceName } }}</p>
          }
      } @else {
        <div class="stencil-shimmer"></div>
        <div class="stencil-shimmer"></div>
        <div class="stencil-shimmer"></div>
      }
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-stroked-button mat-dialog-close tabIndex="-1">
      {{ 'COMMON.CLOSE' | translate }}
    </button>
    <button mat-flat-button color="primary" (click)="overridePrivacyLevel()" [disabled]="changingPrivacyLevel">
      {{ 'COMMON.SAVE' | translate }}
    </button>
  </mat-dialog-actions>
  